export default __webpack_public_path__ + "public/icons/executeTestCase.png?e180ccea0da3d618d28c35621d11d46a";